<template>
  <div id="details">
    <!--banner-->
    <div class="swiper-container swiper-no-swiping common" id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-slide-banner">
          <img src="https://img.deepbaytech.com/images2021/nvidia_dgx.png" alt="">
          <div class="swiper-slide-title swiper-slide-title-nvidia">
            <div style="font-size: 40px;">NVIDIA DGX A800</div>
            <div style="font-size: 16px;margin-top:20px;margin-bottom:40px;width: 664px;">NVIDIA
              DGX™ A100 是适用于所有 AI 工作负载的通用系统，为全球首款 5 petaFLOPS AI 系统提供超高的计算密度、性能和灵活性。NVIDIA DGX A800
              采用全球超强大的加速器 NVIDIA A100 Tensor Core GPU，可让企业将深度学习训练、推理和分析整合至一个易于部署的统一 AI
              基础架构中，该基础架构具备直接联系 NVIDIA AI 专家的功能。</div>
            <a href="/cooperation" class="service">立即咨询</a>
            <a href="/" class="download">下载性能数据表</a>
            <a href="/" class="download">下载信息图</a>
          </div>
        </div>
      </div>
    </div>
    <!--container-->
    <div class="container">
      <p style="font-size: 28px;text-align: center;margin-bottom: 60px;">AI 数据中心的基本组成部分</p>
      <div class="container-text">
        <div class="container-text-item">
          <div style="text-align:center;">
            <img src="https://img.deepbaytech.com/images2021/icon_system.png">
          </div>
          <p class="item-t">人工智能超级运算</p>
          <p class="item-c">借助 DGX Station A100，企业可以使用与其他基于 NVIDIA DGX™
            基础架构无缝集成的系统为多个用户提供适用于所有工作负载的集中式 AI 资源 - 训练、推理和数据分析。借助多实例 GPU (MIG)，可为单个用户分配多达 28 台独立 GPU
            设备。</p>
        </div>
        <div class="container-text-item">
          <div style="text-align:center;">
            <img src="https://img.deepbaytech.com/images2021/icon_system.png">
          </div>
          <p class="item-t">人工智能超级运算</p>
          <p class="item-c">借助 DGX Station A100，企业可以使用与其他基于 NVIDIA DGX™
            基础架构无缝集成的系统为多个用户提供适用于所有工作负载的集中式 AI 资源 - 训练、推理和数据分析。借助多实例 GPU (MIG)，可为单个用户分配多达 28 台独立 GPU
            设备。</p>
        </div>
        <div class="container-text-item">
          <div style="text-align:center;">
            <img src="https://img.deepbaytech.com/images2021/icon_system.png">
          </div>
          <p class="item-t">人工智能超级运算</p>
          <p class="item-c">借助 DGX Station A100，企业可以使用与其他基于 NVIDIA DGX™
            基础架构无缝集成的系统为多个用户提供适用于所有工作负载的集中式 AI 资源 - 训练、推理和数据分析。借助多实例 GPU (MIG)，可为单个用户分配多达 28 台独立 GPU
            设备。</p>
        </div>
        <div class="container-text-item">
          <div style="text-align:center;">
            <img src="https://img.deepbaytech.com/images2021/icon_system.png">
          </div>
          <p class="item-t">人工智能超级运算</p>
          <p class="item-c">借助 DGX Station A100，企业可以使用与其他基于 NVIDIA DGX™
            基础架构无缝集成的系统为多个用户提供适用于所有工作负载的集中式 AI 资源 - 训练、推理和数据分析。借助多实例 GPU (MIG)，可为单个用户分配多达 28 台独立 GPU
            设备。</p>
        </div>
      </div>
    </div>
    <!--系统规格-->
    <div class="system-specifications">
      <div class="system-specifications-in">
        <p style="font-size: 28px;color: #333333;line-height: 40px;text-align: center;margin-bottom: 40px;">
          系统规格</p>
        <el-table :data="tableData" border style="width: 100%;">
          <el-table-column prop="GPU" align="center" label="GPU规格" width="589px">
          </el-table-column>
          <el-table-column prop="NVIDIA" align="center" label="NVIDIA RTX A6000" width="590px">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--组件-->
    <div class="component">
      <p style="font-size: 28px;color: #77BA00;line-height: 40px;text-align: center;margin-bottom: 40px;">
        探索功能强大的 DGX A800 组件</p>
      <div class="component-container">
        <img class="dgx" src="https://img.deepbaytech.com/images2021/DGX.png">
        <div>
          <el-badge :value="1" type="success" />
          <sapn class="badge-span">八块 NVIDIA A100 GPU，GPU 总显存高达 640 GB</sapn>
          <p class="badge-p">每块 GPU 支持 12 个 NVLink 连接， GPU 至 GPU 带宽高达 600 GB/s</p>
          <el-badge :value="2" type="success" />
          <sapn class="badge-span">六个第二代 NVSWITCH</sapn>
          <p class="badge-p">双向带宽高达 4.8 TB/s， 比上一代产品高出 2 倍</p>
          <el-badge :value="3" type="success" />
          <sapn class="badge-span">九个 Mellanox ConnectX-6 VPI HDR InfiniBand/200 Gb 以太网</sapn>
          <p class="badge-p">双向带宽峰值高达 500 GB/s</p>
          <el-badge :value="4" type="success" />
          <sapn class="badge-span">两块 64 核 AMD CPU 和 2 TB 系统内存</sapn>
          <p class="badge-p">以 3.2 倍核心数量满足超密集的 AI 作业</p>
          <el-badge :value="5" type="success" />
          <sapn class="badge-span">30 TB 第四代 NVME SSD</sapn>
          <p class="badge-p">带宽峰值高达 50 GB/s，比三代 NVME SSD 快两倍</p>
        </div>
      </div>
    </div>
    <!--服务咨询-->
    <Consultation class="common" />
    <!-- 尾部 -->
    <Footer class="common" />
  </div>
</template>

<script>
import Consultation from "./../../components/Consultation/Consultation"
import Footer from "./../../components/Footer/Footer"
export default {
  name: "Details",
  components: {
    Consultation,
    Footer
  },
  data () {
    return {
      tableData: [
        {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        },
        {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        }, {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        }, {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        }, {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        }, {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        }, {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        }, {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        }, {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        }, {
          GPU: 'GPU显存',
          NVIDIA: '带纠错码的 48 GB GDDR6'
        },
      ]
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.common {
  min-width: 1180px;
}
.swiper-container {
  height: 480px;
}
.swiper-slide-banner {
  width: 100%;
  height: 480px !important;
}
.swiper-slide {
  position: relative;
  background-size: cover;
}
.swiper-slide-title {
  color: #fff;
  width: 1180px;
  margin: 0 auto;
  padding-top: 170px;
}
.service {
  font-size: 16px;
  margin-right: 16px;
  text-decoration: none;
  display: inline-block;
  padding-left: 24px;
  padding-right: 24px;
  background: #77ba00;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
}
.download {
  font-size: 16px;
  margin-right: 16px;
  text-decoration: none;
  display: inline-block;
  padding-left: 24px;
  padding-right: 24px;
  background: #ffffff;
  color: #77ba00;
  text-align: center;
  line-height: 38px;
}
.container {
  background-color: #fff;
  width: 1180px;
  margin: auto;
  padding-top: 60px;
}
.container-text {
  display: flex;
  flex-wrap: wrap;
}
.container-text-item {
  margin-right: 40px;
  margin-bottom: 40px;
}
.item-t {
  text-align: center;
  margin: 40px 0 12px 0;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
}
.item-c {
  width: 260px;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
}
.container-text-item:nth-child(4n) {
  margin-right: 0px;
}
.container-text-item img {
  width: 130px;
  height: 130px;
}
.system-specifications {
  background: #f6f8fb;
  width: 100%;
  margin-top: 76px;
}
.system-specifications-in {
  width: 1180px;
  margin: auto;
  padding: 60px 0 60px 0;
}
.component {
  width: 1180px;
  margin: auto;
  padding: 60px 0 132px 0;
}
.component-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.dgx {
  width: 580px;
  height: 382px;
  margin-right: 67px;
}
.badge-span {
  font-size: 16px;
  color: #77ba00;
  line-height: 22px;
  margin-left: 8px;
}
.badge-p {
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  padding: 8px 0 19px 28px;
}
</style>
